module.exports = __webpack_public_path__ + "logo-white.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-white.png
// module id = 719
// module chunks = 0